// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionTitle_container__2XPhN","whiteColor":"SectionTitle_whiteColor__2SwhP"};